import * as Act from '@/services/legal-ad-form/components/act';
import * as Appointments from '@/services/legal-ad-form/components/appointments/sas';
import * as AuditorInformation from '@/services/legal-ad-form/components/auditor-information';
import * as Company from '@/services/legal-ad-form/components/company';
import * as GeneralMeetings from '@/services/legal-ad-form/components/general-meetings';
import * as HeadOffice from '@/services/legal-ad-form/components/head-office';
import * as Person from '@/services/legal-ad-form/components/transformation/person';
import { trimObject } from '@/shared/utils';

export default {
  id: 'sas',
  label: 'Avis de constitution SAS',
  shortLabel: 'Avis de constitution',
  componentsData: {
    act: { type: '' },
    company: { legalForm: 'Société par actions simplifiée' },
    headOffice: {},
    generalMeetings: {},
    appointments: { enabled: true },
    chairman: {},
    chiefExecutiveList: [],
    boardMemberList: [],
    mainAuditor: {},
    alternateAuditor: {},
    auditorInformation: {}
  },
  component: () => import('@/components/legal-ads/forms/models/registration/sas.vue'),
  validate(modelData) {
    return trimObject({
      act: Act.validate(modelData.act),
      company: Company.validate(modelData.company, {
        skip: ['sharesTransferClause']
      }),
      headOffice: HeadOffice.validate(modelData.headOffice),
      generalMeetings: GeneralMeetings.validate(modelData.generalMeetings),
      chiefExecutiveList: Person.validateMany(modelData.chiefExecutiveList, false),
      ...Appointments.validate(modelData),
      ...AuditorInformation.validate(modelData),
    });
  },
  buildContent(modelData) {
    return [
      Act.buildContent(modelData.act, 'une société'),
      Company.buildContent(modelData.company),
      HeadOffice.buildContent(modelData.headOffice),
      GeneralMeetings.buildContent(modelData.generalMeetings),
      Appointments.buildContent(modelData),
      AuditorInformation.buildContent(modelData),
      Person.buildManyContent(modelData.chiefExecutiveList, 'En qualité de directeur général'),
      HeadOffice.buildRegistrationContent(modelData.headOffice),
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};
